// Browsers surface the document.title prefix on the tab, giving users
// a passive "you have something to look at" signal even when they're
// on another page. The indicator self-replaces via hx-swap="outerHTML"
// so we re-query on every htmx swap rather than binding to the
// indicator element directly (it's gone after each swap).
function updateNotificationTitle() {
  const indicator = document.getElementById("notification-unread-indicator");
  const raw = indicator ? indicator.dataset.unreadCount : "";
  const count = raw ? parseInt(raw, 10) || 0 : 0;
  const base = document.title.replace(/^\(\d+\)\s*/, "");
  document.title = count > 0 ? `(${count}) ${base}` : base;
}

export function initNotifications(_root) {
  updateNotificationTitle();
}

// Cancel the swap when the polled count hasn't changed. Otherwise the
// 15s poll would replace the indicator with byte-identical markup,
// re-firing the @starting-style entrance animation on every tick and
// making the badge flicker.
document.body.addEventListener("htmx:beforeSwap", (event) => {
  const target = event.detail.target;
  if (!target || target.id !== "notification-unread-indicator") return;
  const match = event.detail.serverResponse.match(/data-unread-count="(\d+)"/);
  if (match && match[1] === target.dataset.unreadCount) {
    event.detail.shouldSwap = false;
  }
});

document.body.addEventListener("htmx:afterSwap", () => {
  updateNotificationTitle();
});
